import React from "react";
import HOC from "../../../components/HOC";
import { theme } from "../../../components/constants/muiTheme";
import AllocationList from "../../../components/screen/centralWarehouse/allocation/AllocationList";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";

const AllocationListPage = () => {
  return (
    <div className="">
      <PageTemplate
        header="Allocation"
        mainComponent={
          <ThemeProvider theme={theme}>
            <AllocationList />
          </ThemeProvider>
        }
        pageRole={34}
        noPadding={true}
      />
    </div>
  );
};

export default HOC(AllocationListPage);
